import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import { LayoutTypes } from '~/constants/ui.constants';

export const FooterMixin = defineNuxtComponent({
  computed: {
    ...mapState(useWebsiteStore, ['layouts', 'currentPage']),

    footerLayout() {
      return this.layouts.find((layout) => layout.layout.name === LayoutTypes.FOOTER);
    },

    footerComponents() {
      if (this.currentPage && this.currentPage.footer && this.currentPage.footer.length) {
        return this.currentPage.footer;
      } else if (this.footerLayout && this.footerLayout.components && this.footerLayout.components.length) {
        return this.footerLayout.components;
      }
      return [];
    },
  },
});
